"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReduxSwitch;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../../utils");
var _excluded = ["checked", "onChange", "value"],
  _excluded2 = ["checked", "input"];
function ReduxSwitch(_ref) {
  var switchChecked = _ref.checked,
    _ref$input = _ref.input,
    checked = _ref$input.checked,
    onChange = _ref$input.onChange,
    value = _ref$input.value,
    inputProps = (0, _objectWithoutProperties2.default)(_ref$input, _excluded),
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded2);
  return /*#__PURE__*/_react.default.createElement(_material.Switch, (0, _extends2.default)({}, inputProps, props, {
    // Support reduxForm & reduxFinalForm both
    checked: (0, _utils.hasValue)(checked) ? !!checked : !!value,
    onChange: onChange
  }));
}